import React from 'react';
import InvestmentCard from './InvestmentCard';
import { ChartPieSlice } from '@phosphor-icons/react';

const InvestmentsTable = ({
  investments,
  onStockTitleClick,
  onDeleteClick,
  onUpdateSettingsClick,
}) => {
  if (!investments || !Array.isArray(investments) || investments.length === 0) {
    return (
      <div className="empty-investments-state">
        <div className="empty-icon-wrap">
          <ChartPieSlice size={40} weight="duotone" />
        </div>
        <h3>No Active Investments</h3>
        <p>
          Add a stock to start 7-Split automated value investing. Click the +
          button in the top header.
        </p>
      </div>
    );
  }

  return (
    <section className="investments-section">
      <div className="investments-container">
        {investments.map(investment => (
          <InvestmentCard
            key={investment.id || investment.stock.ticker}
            investment={investment}
            onStockTitleClick={onStockTitleClick}
            onDeleteClick={onDeleteClick}
            onUpdateSettingsClick={onUpdateSettingsClick}
          />
        ))}
      </div>
    </section>
  );
};

export default InvestmentsTable;
